// Meta Pixel for the public web pages — loaded ONLY after the visitor allows
// advertising cookies in the cookie banner (event 'helfer-consent'). Never in
// the desktop app, the guest menu or staff screens.
// Fill META_PIXEL_ID with the ID of the Cafe Local dataset (Events Manager);
// a pixel ID is public, so it can live in the code.
import type { Router } from 'vue-router';

export const META_PIXEL_ID = '1432924502126062';

type Fbq = ((...args: unknown[]) => void) & { callMethod?: (...a: unknown[]) => void; queue: unknown[]; loaded: boolean; version: string; push: unknown };
type W = Window & { fbq?: Fbq; _fbq?: Fbq; helferConsent?: { ads?: boolean } | null; __CAFE_DESKTOP_RUNTIME__?: unknown };
const w = window as W;
const PRIVATE_PATH = /^\/(v2|table|admin|kitchen|storefront|desktop-entry|login|old)(\/|$)/i;
let loaded = false;
let adsAllowed = false;

const allowedHere = () => !w.__CAFE_DESKTOP_RUNTIME__ && !PRIVATE_PATH.test(window.location.pathname);

function load() {
  if (loaded || !META_PIXEL_ID || !allowedHere()) return;
  loaded = true;
  // Meta's standard loader, written out.
  const f = function fbq(...args: unknown[]) {
    if (f.callMethod) f.callMethod(...args); else f.queue.push(args);
  } as Fbq;
  f.push = f; f.loaded = true; f.version = '2.0'; f.queue = [];
  w.fbq = f; if (!w._fbq) w._fbq = f;
  const s = document.createElement('script');
  s.async = true;
  s.src = 'https://connect.facebook.net/en_US/fbevents.js';
  document.head.appendChild(s);
  f('init', META_PIXEL_ID);
  f('track', 'PageView');
}

/** A standard event (e.g. 'Lead' on a download button). Does nothing without consent. */
export function trackPixel(event: string, params?: Record<string, unknown>) {
  if (adsAllowed && loaded && w.fbq && allowedHere()) w.fbq('track', event, params || {});
}

export function setupMetaPixel(router: Router) {
  const apply = (c: { ads?: boolean } | null | undefined) => {
    adsAllowed = !!(c && c.ads);
    if (adsAllowed) { load(); if (w.fbq) w.fbq('consent', 'grant'); } else if (loaded && w.fbq) w.fbq('consent', 'revoke');
  };
  window.addEventListener('helfer-consent', (e) => apply((e as CustomEvent).detail));
  apply(w.helferConsent);
  // A single-page site: every page change is a page view.
  let first = true;
  router.afterEach(() => {
    if (first) { first = false; return; }
    if (adsAllowed && loaded && w.fbq && allowedHere()) w.fbq('track', 'PageView');
  });
}
